import { AnyAction } from 'redux';
import { ApiStatuses } from '../../../../global/models/api-model';
import { BeneficiaryActions, BeneficiaryState } from './model/beneficiary-models';




const InitialState: BeneficiaryState =
{
	loaded: false,
	beneficiaries: null,
	createNewBeneficiaryStatus: ApiStatuses.None,
	relationshipsLoaded: false,
	relationships: null,
};


export const beneficiaciesReducer = (state = InitialState, action: AnyAction): BeneficiaryState => {

	switch (action.type) {

		case BeneficiaryActions.SET_BENEFICIARIES:
			return {
				...state,
				loaded: true,
				beneficiaries: action.payload,
			};

		case BeneficiaryActions.CLEAR_BENEFICIARIES:
			return {
				...state,
				loaded: false,
				beneficiaries: null,
			};

		case BeneficiaryActions.SET_CREATE_BENEFICIARY_STATUS:
			return {
				...state,				
				createNewBeneficiaryStatus: action.status,
			};

		case BeneficiaryActions.SET_BENEFICIARIES_RELATIONSHIPS:
			return {
				...state,
				relationshipsLoaded: true,
				relationships: action.payload,
			};

		case BeneficiaryActions.CLEAR_BENEFICIARIES_RELATIONSHIPS:
			return {
				...state,
				relationshipsLoaded: false,
				relationships: null,
			};

		default: return state;
	}
};


export const setBeneficiaries = (payload: any) => {
	return {
		type: BeneficiaryActions.SET_BENEFICIARIES,
		payload,
	};
};

export const setCreateBeneficiaryStatus = (status: ApiStatuses) => {
	return {
		type: BeneficiaryActions.SET_CREATE_BENEFICIARY_STATUS,
		status,
	};
};

export const setBeneficiariesRelationships = (payload: any) => {
	return {
		type: BeneficiaryActions.SET_BENEFICIARIES_RELATIONSHIPS,
		payload,
	};
};

export const clearBeneficiaries = () => {
	return {
		type: BeneficiaryActions.CLEAR_BENEFICIARIES,		
	};
};

export const clearBeneficiariesRelationships = () => {
	return {
		type: BeneficiaryActions.CLEAR_BENEFICIARIES_RELATIONSHIPS,		
	};
};
